import { doc, collection, getDocs, getDoc } from 'firebase/firestore';
import { dbFirestore } from '../appFirebase';
import { addDocToCollection, updateDocToCollection } from './dbUtils';

// get demographics data
// doc.data() is never undefined for query doc snapshots
// console.log(demographic.id, ' => ', demographic.data());
// Manage Sessions
export const getSessions = async () => {
	const querySnapshot = await getDocs(collection(dbFirestore, 'events'));
	const sessions = [];
	querySnapshot.forEach(session => {
		sessions.push({ id: session.id, ...session.data() });
	});
	return sessions;
};

export const getSessionDetails = sessionId => {
	const sessionRef = doc(dbFirestore, 'events', sessionId);
	return getDoc(sessionRef).then(docSnap => {
		if (docSnap.exists()) {
			return docSnap.data();
		}
	});
};

export const addSession = async newSession => {
	const session = await addDocToCollection('events', { ...newSession });
	return { id: session.id, ...newSession };
};

export const updateSession = (sessionId, updatedSession) => {
	updateDocToCollection(sessionId, 'events', updatedSession);
	return { id: sessionId, ...updatedSession };
};
